var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H19C23.4183 0 27 3.58172 27 8C27 12.4183 23.4183 16 19 16H8C3.58172 16 0 12.4183 0 8Z",
    fill: "#F6F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61119 12H8.32994L11.2088 4H12.6034L15.4823 12H14.201L11.9393 5.45312H11.8768L9.61119 12ZM9.82604 8.86719H13.9823V9.88281H9.82604V8.86719ZM18.0646 4V12H16.8576V4H18.0646Z",
    fill: "#525866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewAi);
export default __webpack_public_path__ + "static/media/interview-ai.d79c9d25c0644e3c264b8ae22d1c0629.svg";
export { ForwardRef as ReactComponent };